const baseURL = 'https://taxbot.prismberry.com'

export const API_URLS ={
    USER_REGISTRATION: `${baseURL}/api/v1/auth`,
    SEND_QUESTION:`${baseURL}/api/v1/message/ui`,
    FATCH_MASSAGES:`${baseURL}/api/v1/message/get`,
} as const